import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC } from 'react';
import styles from './styles.scss';

const TeamSection: FC<{}> = () => {
	const { width } = useResizeObserver();
	const { transData, list } = useTranslation('partner.team');

	return (
		<section className={styles['ac-team']} id="team">
			<div className={styles['ac-team-container']}>
				<div dangerouslySetInnerHTML={{ __html: transData.title }} />
				<div className={styles['ac-team-content']}>
					{(list as any[]).map((item, i) => {
						return (
							<div className={styles['ac-team-item']} key={i}>
								<img className={styles['team-img-1']} loading="lazy" src={item.img} alt="" />
								<p>{item.desc}</p>
							</div>
						);
					})}
				</div>
			</div>
		</section>
	);
};

export default TeamSection;
